import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import { useNavigate } from 'react-router-dom';
import { apiHelper, baseUrl } from 'helpers/util';
import { notify } from 'helpers/globalFunctions';

import ColumnBox from 'components/ColumnBox';
import RowBox from 'components/RowBox';
import CardList from 'components/CardList';
import CardItem from 'components/CardItem';
import SmallHeading from 'components/SmallHeading';


export default function Form(props) {
    const navigate = useNavigate();
    const [ itemId, setProductId ] = useState(null);
    const [ itemName, setItemName ] = useState('');
    const [ itemCost, setItemCost ] = useState('');
    const [ isInactive, setIsInactive] = useState(false);

    const [ products, setProducts ] = useState([]);

    const [ isFormSubmitting, setIsFormSubmitting ] = useState(false);

    const fillProductDetails = function(productInfo) {
        setProductId(productInfo ? productInfo.name : null);
        setItemName(productInfo ? productInfo.item_name : '');
        setIsInactive(productInfo ? productInfo.is_inactive : false);
        setItemCost(productInfo ? productInfo.item_cost : '');
    }

    const loadProducts = function() {
        const apiParams = {
            "doctype": "FOLK Billing Item",
            "fields": JSON.stringify([ "name", "item_name", "item_cost", "is_inactive" ]),
            "order_by": "item_name asc",
            "limit": 1000,
        }
        apiHelper.get({ "url": `${baseUrl}/.netlify/functions/erp_api`,
            "params": apiParams })
        .then(response => {
            if (response.status) { setProducts(response.json.data); }
            else { console.log(response.json); }
        })
    }

    const onClickSave = function() {
        const payload = {
            'item_name': itemName,
            'is_inactive': isInactive,
            'item_cost': itemCost
        }

        const apiParams = { "doctype": "FOLK Billing Item" };
        itemId && (apiParams["name"] = itemId)

        setIsFormSubmitting(true);
        let apiUrl = `${baseUrl}/.netlify/functions/erp_api`;
        let apiPromise = null;
        if (itemId) {
            apiPromise = apiHelper.put({ "url": apiUrl, "params": apiParams, "data": payload })
        } else {
            apiPromise = apiHelper.post({ "url": apiUrl, "params": apiParams, "data": payload })
        }
        apiPromise
        .then(response => {
            if (response.status) {
                setIsFormSubmitting(false);
                fillProductDetails();
                loadProducts();
                notify.success({ "description": "Product successfully added !" })
            } else { console.log(response.json); setIsFormSubmitting(false); }
        })
    }

    useEffect(function() {
        loadProducts();
    }, []);
 
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',
            padding: '15px' }}>
            <ColumnBox>
                <SmallHeading>Add / Edit Item</SmallHeading>
                <ColumnBox sx={{ alignItems: 'center', maxWidth: '500px',
                    width: '100%' }}>
                    <TextField label="Item Name"
                        onChange={(e) => setItemName(e.target.value)}
                        value={itemName}
                        sx={{ width: '100%', marginTop: '15px' }}
                        type="text"
                        size="small"
                    />
                    <FormControlLabel sx={{ alignSelf: 'flex-start' }}
                        control={<Checkbox size="small" checked={isInactive}
                        onChange={ e => setIsInactive(e.target.checked) } />}
                        label="Inactive ?" />

                    <TextField label="Item Cost"
                        onChange={(e) => setItemCost(e.target.value)}
                        value={itemCost}
                        sx={{ width: '100%', marginTop: '15px' }}
                        type="number"
                        size="small"
                    />

                    { isFormSubmitting ? <CircularProgress sx={{ marginTop: '15px' }} /> :
                        <Button sx={{ marginTop: '15px' }} onClick={() => onClickSave()}
                            variant="outlined">Save</Button>
                    }
                </ColumnBox>
                <SmallHeading>Items</SmallHeading>
                <CardList sx={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                    { products.map(p => (
                        <CardItem sx={{ 'cursor': 'pointer', 'minWidth': '70px',
                            'width': 'unset', 'maxWidth': '200px', 'margin': '10px 5px' }}
                            onClick={() => fillProductDetails(p)}>
                            <Box>{`${p.item_name}${p.is_inactive ? ' 🚫' : '' }`}</Box>
                            <RowBox>
                                <Box>{p.cost !== null && `₹ ${p.item_cost}` }</Box>
                            </RowBox>
                        </CardItem>
                    )) }
                </CardList>
            </ColumnBox>
        </Box>
    );
}
